import { HttpClient } from '@angular/common/http';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var EXCEL_TYPE = 'application/csv;charset=UTF-8';
var EXCEL_EXTENSION = '.xlsx';
var BpgEventsService = /** @class */ (function () {
    function BpgEventsService(http, 
    // private logger:BPGLoggerService,
    bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.URI = ConstantValues.eventManagementApiUrl.eventManagementUrl;
        this.userUrl = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.eventListApi = ConstantValues.eventManagementApiUrl.eventCalendarList;
        this.chapterDropDownListApi = ConstantValues.commonApiUrl.eventChapterDropDownList;
        this.eventTypeListForDropDownApi = ConstantValues.eventManagementApiUrl.eventTypeList;
        this.hoshinListForDropDownApi = ConstantValues.eventManagementApiUrl.hoshinList;
        this.createEventApi = ConstantValues.eventManagementApiUrl.createEvent;
        this.uploadFileApi = ConstantValues.eventManagementApiUrl.uploadFile;
        this.getAwsUrl = ConstantValues.eventManagementApiUrl.awsUrls;
        this.evevntRegistrationApi = ConstantValues.eventManagementApiUrl.eventRegistration;
        this.eventRegistrationForGroupApi = ConstantValues.eventManagementApiUrl.eventRegistrationForGroup;
        this.evevntAttendanceApi = ConstantValues.eventManagementApiUrl.eventAttendance;
        this.getCountOfSignedUserByEventId = ConstantValues.eventManagementApiUrl.countOfSignedUser;
        this.getSignedUnsignedUserByEventId = ConstantValues.eventManagementApiUrl.signedUnsignedUser;
        this.eventStatusUpdateApi = ConstantValues.eventManagementApiUrl.eventStatusUpdate;
        this.expenseStatusUpdateApi = ConstantValues.eventManagementApiUrl.expenseStatusUpdate;
        this.surveyStandardQuestionAnswersApi = ConstantValues.eventManagementApiUrl.getSurveyStandardQuestionAnswers;
        this.takeSurveyListApi = ConstantValues.eventManagementApiUrl.getTakeSurveyList;
        this.saveSurveyResponseApi = ConstantValues.eventManagementApiUrl.saveSurveyResponse;
        this.createSurveyApi = ConstantValues.eventManagementApiUrl.createSurvey;
        this.getSurveyIdApi = ConstantValues.eventManagementApiUrl.getSurveyId;
        this.getSurveyQuestionsApi = ConstantValues.eventManagementApiUrl.getSurveyQuestions;
        this.suveyTakenByUserApi = ConstantValues.eventManagementApiUrl.suveyTakenByUser;
        this.listAttendanceApi = ConstantValues.eventManagementApiUrl.listAttendance;
        this.listEventReportApi = ConstantValues.eventManagementApiUrl.getEventReport;
        this.getGroupSignupDetailsApi = ConstantValues.eventManagementApiUrl.getGroupSignupDetails;
        this.removeFromEventGroupApi = ConstantValues.eventManagementApiUrl.removeFromEventGroup;
        this.printEventListApi = ConstantValues.eventManagementApiUrl.printEventsInFY;
        this.getBudgetActualsDataApi = ConstantValues.eventManagementApiUrl.getBudgetActualsData;
    }
    /** For service call to get all Events
   * @class EventCalendarService
   * @method getAllEvents
   * @param landingData
   * @returns Observable
   */
    BpgEventsService.prototype.getAllEvents = function (landingData) {
        return this.http.post(this.URI + this.eventListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get all Chapter dropdown
     * @class EventCalendarService
     * @method getChapterDropDown
     * @param landingData
     * @returns Observable
     */
    BpgEventsService.prototype.getChapterDropDown = function (userAndRoleIdDTO) {
        return this.http.post(this.userUrl + this.chapterDropDownListApi, userAndRoleIdDTO, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get all Chapter dropdown
   * @class EventCalendarService
   * @method getEventTypeListForDropDown
   * @param
   * @returns Observable
   */
    BpgEventsService.prototype.getEventTypeListForDropDown = function () {
        return this.http.post(this.URI + this.eventTypeListForDropDownApi, {}, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get all hoshin dropdown
  * @class EventCalendarService
  * @method getHoshinListForDropDown
  * @param
  * @returns Observable
  */
    BpgEventsService.prototype.getHoshinListForDropDown = function (landingDTOModel) {
        return this.http.post(this.URI + this.hoshinListForDropDownApi, landingDTOModel, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save event
  * @class EventCalendarService
  * @method saveEvent
  * @param eventFormData
  * @returns Observable
  */
    BpgEventsService.prototype.saveEvent = function (eventFormData) {
        return this.http.post(this.URI + this.createEventApi, eventFormData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to upload file
  * @class EventCalendarService
  * @method uploadFile
  * @param eventFormData
  * @returns Observable
  */
    BpgEventsService.prototype.uploadFile = function (files, action, id) {
        var formdata = new FormData();
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            formdata.append('file', file);
        }
        formdata.append('action', action);
        formdata.append('id', id);
        return this.http.post(this.URI + this.uploadFileApi, formdata, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save event
     * @class EventCalendarService
     * @method saveEvent
     * @param eventFormData
     * @returns Observable
     */
    BpgEventsService.prototype.getAwsUrlsApi = function (eventDetails) {
        return this.http.post(this.URI + this.getAwsUrl, eventDetails, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save/cancel event registration
     * @class EventCalendarService
     * @method saveEvent
     * @param eventFormData
     * @returns Observable
     */
    BpgEventsService.prototype.saveEventRegistration = function (eventRegistrationDetails) {
        return this.http.post(this.URI + this.evevntRegistrationApi, eventRegistrationDetails, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save/cancel event registration
   * @class EventCalendarService
   * @method saveEvent
   * @param eventFormData
   * @returns Observable
   */
    BpgEventsService.prototype.saveEventForGroupRegistration = function (eventRegistrationDetails) {
        return this.http.post(this.URI + this.eventRegistrationForGroupApi, eventRegistrationDetails, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get the number of members signed in
     * @class EventRegistrationService
     * @method getCountOfSignedUser
     * @param eventId
     * @returns Observable
     */
    BpgEventsService.prototype.getCountOfSignedUser = function (eventId) {
        return this.http.post(this.URI + this.getCountOfSignedUserByEventId + eventId, {}, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get the signed and unsigned user
      * @class EventRegistrationService
      * @method getSignedUnsignedUser
      * @param userId,eventId
      * @returns Observable
      */
    BpgEventsService.prototype.getSignedUnsignedUser = function (eventId, userId) {
        return this.http.post("" + this.URI + this.getSignedUnsignedUserByEventId + eventId + "/" + userId, {}, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to update event status
    * @class EventCalendarService
    * @method updateEventStatus
    * @param landingDto
    * @returns Observable
    */
    BpgEventsService.prototype.updateEventStatus = function (landingDto) {
        return this.http.post(this.URI + this.eventStatusUpdateApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BpgEventsService.prototype.landingDto = function () {
        return {
            "approvalComment": "string",
            "approvedBy": 0,
            "eventId": 0,
            "eventStatus": "NEW",
        };
    };
    /** For service call to save User Attendance
     * @class EventCalendarService
     * @method saveUserAttendance
     * @param UserAttendanceDetails
     * @returns Observable
     */
    BpgEventsService.prototype.saveUserAttendance = function (UserAttendanceDetails) {
        return this.http.post(this.URI + this.evevntAttendanceApi, UserAttendanceDetails, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to update expense status
     * @class EventCalendarService
     * @method updateExpenseStatus
     * @param landingDto
     * @returns Observable
     */
    BpgEventsService.prototype.updateExpenseStatus = function (landingDto) {
        return this.http.post(this.URI + this.expenseStatusUpdateApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BpgEventsService.prototype.landingDto1 = function () {
        return {
            "approvalComment": "string",
            "approvedBy": 0,
            "expenseId": 0,
            "expenseStatus": "NEW",
        };
    };
    /** For service call to get std survey question/answer
    * @class EventService
    * @method getSurveyStdQuestionAnswers
    * @param landingDto
    * @returns Observable
    */
    BpgEventsService.prototype.getSurveyStdQuestionAnswers = function (landingDto) {
        return this.http.post(this.URI + this.surveyStandardQuestionAnswersApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get the Questions and Answers For the Events
    * @class TakeSurveyService
    * @method getQuestionAnswers
    * @param userId,eventId
    * @returns Observable
    */
    BpgEventsService.prototype.getQuestionAnswers = function (landingData) {
        return this.http.post(this.URI + this.takeSurveyListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to save Servey
     * @class TakeSurveyComponent
     * @method saveResponseSurvey
     * @param UserAttendanceDetails
     * @returns Observable
     */
    BpgEventsService.prototype.saveResponseSurvey = function (SurveyResopnseDetails) {
        return this.http.post(this.URI + this.saveSurveyResponseApi, SurveyResopnseDetails, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to create a survey
    * @class EventService
    * @method getSurveyStdQuestionAnswers
    * @param landingDto
    * @returns Observable
    */
    BpgEventsService.prototype.createSurvey = function (landingDto) {
        return this.http.post(this.URI + this.createSurveyApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get the All Std Questions and Answers For the Survey
    * @class EventService
    * @method getSurveyQuestions
    * @param landingDto
    * @returns Observable
    */
    BpgEventsService.prototype.getSurveyQuestions = function (landingDto) {
        return this.http.post(this.URI + this.getSurveyQuestionsApi, landingDto, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get the Survey Id and details
       * @class BpgEventsService
       * @method getSurveyId
       * @param landingData
       * @returns Observable
       */
    BpgEventsService.prototype.getSurveyId = function (landingData) {
        return this.http.post(this.URI + this.getSurveyIdApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get the group sign up details
       * @class BpgEventsService
       * @method getGroupSignupDetails
       * @param landingData
       * @returns Observable
       */
    BpgEventsService.prototype.getGroupSignupDetails = function (eventId, userId) {
        return this.http.post("" + this.URI + this.getGroupSignupDetailsApi + eventId + "/" + userId, {}, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to remove user from event sign up
     * @class BpgEventsService
     * @method removeFromEventGroup
     * @param landingData
     * @returns Observable
     */
    BpgEventsService.prototype.removeFromEventGroup = function (eventId, userId) {
        return this.http.post("" + this.URI + this.removeFromEventGroupApi + eventId + "/" + userId, {}, this.bpgCommonService.tokenizedHeader())
            .pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to check whether user taken the survey
       * @class BpgEventsService
       * @method suveyTakenByUser
       * @param landingData
       * @returns Observable
       */
    BpgEventsService.prototype.suveyTakenByUser = function (landingData) {
        return this.http.post(this.URI + this.suveyTakenByUserApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to list User Attendance data
       * @class BpgEventsService
       * @method suveyTakenByUser
       * @param landingData, eventId
       * @returns Observable
       */
    BpgEventsService.prototype.listAttendance = function (landingData) {
        return this.http.post(this.URI + this.listAttendanceApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to list User Attendance data
       * @class BpgEventsService
       * @method suveyTakenByUser
       * @param landingData, eventId
       * @returns Observable
       */
    BpgEventsService.prototype.listEventReport = function (landingData) {
        return this.http.post(this.URI + this.listEventReportApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For converting json to csv and saving the file
       * @class BpgEventsService
       * @method exportAsExcelFile
       * @param json data, string
       */
    BpgEventsService.prototype.exportAsExcelFile = function (json, excelFileName) {
        var worksheet = XLSX.utils.json_to_sheet(json);
        var workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        var excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    };
    BpgEventsService.prototype.saveAsExcelFile = function (buffer, fileName) {
        var data = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName.trim() + EXCEL_EXTENSION);
    };
    /** For service call to get all Events for printing
   * @class EventCalendarService
   * @method getAllEvents in fiscal year
   * @param landingData
   * @returns Observable
   */
    BpgEventsService.prototype.getAllEventsInFiscalYear = function (landingData) {
        return this.http.post(this.URI + this.printEventListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get all budgte actuals
  * @class EventCalendarService
  * @method getAllBudgetActuals
  * @param landingData
  * @returns Observable
  */
    BpgEventsService.prototype.getBudgetActualsData = function (landingData) {
        return this.http.post(this.URI + this.getBudgetActualsDataApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    BpgEventsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BpgEventsService_Factory() { return new BpgEventsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: BpgEventsService, providedIn: "root" });
    return BpgEventsService;
}());
export { BpgEventsService };
